/**
 * Enregistrement du service worker et stratégie de mise à jour.
 * Une nouvelle version ne s'installe jamais en plein milieu d'une visite :
 * on prévient, et le visiteur décide.
 */
export function registerServiceWorker(onUpdateReady: (apply: () => void) => void): void {
  if (!import.meta.env.PROD) return;
  if (!('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js', { scope: '/' })
      .then((registration) => {
        registration.addEventListener('updatefound', () => {
          const installing = registration.installing;
          if (!installing) return;
          installing.addEventListener('statechange', () => {
            if (installing.state !== 'installed' || !navigator.serviceWorker.controller) return;
            onUpdateReady(() => {
              installing.postMessage('skip-waiting');
              window.location.reload();
            });
          });
        });
      })
      .catch(() => {
        // Un service worker indisponible ne doit pas empêcher la visite.
      });
  });
}
